import React, { createContext } from 'react';
import TokenRefresh from './TokenRefresh';
import { getToken } from '../utils';
import { getAuthUrlParams, useUser } from '../services';
export var AuthContext = createContext({
  user: null,
  token: ''
});
AuthContext.displayName = 'AuthContext';

function AuthProvider(_ref) {
  var children = _ref.children;

  var _getAuthUrlParams = getAuthUrlParams(),
      userId = _getAuthUrlParams.userId,
      token = _getAuthUrlParams.token;

  var _useUser = useUser(userId, token),
      user = _useUser.user,
      loading = _useUser.loading;

  return loading ? React.createElement(React.Fragment, null, "Loading user data...") : React.createElement(AuthContext.Provider, {
    value: {
      user: user,

      get token() {
        return getToken();
      }

    }
  }, children, React.createElement(TokenRefresh, null));
}

function useAuth() {
  var context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  return context;
}

export { AuthProvider, useAuth };